import { render } from "./collection-header.vue?vue&type=template&id=80599c3c"
import script from "./collection-header.vue?vue&type=script&lang=js"
export * from "./collection-header.vue?vue&type=script&lang=js"

import "./collection-header.vue?vue&type=style&index=0&id=80599c3c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__